// Set only by the local build browser; never persisted in the generated HTML.
export const isPrerender =
  typeof window !== "undefined" &&
  (window as Window & { __DEEPSOUL_PRERENDER__?: boolean })
    .__DEEPSOUL_PRERENDER__ === true;
